module.exports = __webpack_public_path__ + "static/media/cmob11.b14ee1de.svg";